import { PageRegistration } from './PageRegistration';
export default PageRegistration;
